import React, {useEffect, useState} from 'react';
import './reviewsSection.scss';
import { Rating } from 'react-simple-star-rating'
import ReviewItem from "./components/ReviewItem";
import {Navigation, Pagination, Mousewheel, Scrollbar, A11y, Virtual, Parallax} from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';
import 'swiper/scss/scrollbar';
import {useTranslation} from "react-i18next";

const ReviewsSection = () => {
	const { t } = useTranslation();
	const [width, setWidth]   = useState(window.innerWidth);

	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}

	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
		}, []);

	const items: any[] = [
		{
			id: 0,
			rate: 5,
			text: t('whatCustomerSay.options.1'),
		},
		{
			id: 1,
			rate: 5,
			text: t('whatCustomerSay.options.2'),
		},
		{
			id: 2,
			rate: 5,
			text: t('whatCustomerSay.options.3'),
		},
		{
			id: 3,
			rate: 5,
			text: t('whatCustomerSay.options.4'),
		},
		{
			id: 4,
			rate: 5,
			text: t('whatCustomerSay.options.5'),
		},
		{
			id: 5,
			rate: 5,
			text: t('whatCustomerSay.options.6'),
		},
		{
			id: 6,
			rate: 5,
			text: t('whatCustomerSay.options.7'),
		},
		{
			id: 7,
			rate: 5,
			text: t('whatCustomerSay.options.8'),
		},
		{
			id: 8,
			rate: 5,
			text: t('whatCustomerSay.options.9'),
		},
		{
			id: 9,
			rate: 5,
			text: t('whatCustomerSay.options.10'),
		},
		{
			id: 10,
			rate: 5,
			text: t('whatCustomerSay.options.11'),
		},
	]

	return (
		<div className="reviews">
			<div className="reviews__content">
				<div className="reviews__content_header">
					<h3>{t('whatCustomerSay.title')}</h3>
				</div>
				<div className="reviews__content_info">
					<div className="reviews__content_info_item">
						<p>{t('whatCustomerSay.happyUsers')}</p>
						<span>97+</span>
					</div>
					<div className="reviews__content_info_item">
						<p>{t('whatCustomerSay.service')}</p>
						<Rating
							initialValue={5}
							readonly={true}
							size={24}
							fillColor={"#F37021"}
						/>
					</div>
					<div className="reviews__content_info_item">
						<p>{t('whatCustomerSay.paySecure')}</p>
						<span>{t('whatCustomerSay.withStripe')}</span>
					</div>
				</div>
				<div className="reviews__content_items">
					<Swiper
						modules={[Pagination, Parallax, Mousewheel]}
						spaceBetween={width > 1439 ? 20 : 10}
						slidesPerView={4}
						navigation
						mousewheel={true}
						pagination={{ clickable: true }}
						onSwiper={(swiper: any) => console.log(swiper)}
						onSlideChange={() => console.log('slide change')}
					>
						{items.map((slideContent: any, index) => (
							<SwiperSlide key={`${slideContent} - ${index}`} virtualIndex={index}>
								<ReviewItem rate={slideContent.rate} text={slideContent.text} />
							</SwiperSlide>
						))}
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default ReviewsSection;